/**
 * `agents.agent_versions.strategy` jsonb: an agent's strategy described in words (thesis, universe, signals, entry,
 * exit, cadence, risk profile) and, once the agent runs one, the platform strategy program it runs
 * (`platform { strategyId, version }`). algo.boo's own executable spec language (versions 2 and 3, its interpreter,
 * backtests and templates) went with lane BOO2: a strategy that runs is a program in the platform's strategy language,
 * saved through the App API (`/v2/strategies`). A stored `spec` of an older version is ignored.
 */
import { z } from 'zod'
import { Strategy } from './strategy-base.js'

/** The platform strategy an agent runs (`/v2/strategies/{id}`), set when its program is saved. */
export const PlatformStrategyRef = z.object({
  strategyId: z.string().regex(/^stg_[0-9a-z]{16,40}$/),
  version: z.number().int().positive(),
})
export type PlatformStrategyRef = z.output<typeof PlatformStrategyRef>

export const StrategyDocument = Strategy.extend({
  platform: PlatformStrategyRef.optional(),
})
export type StrategyDocument = z.output<typeof StrategyDocument>
